import CNPJMask from './CNPJMask';
import CPFMask from './CPFMask';
import CreditCardCvvMask from './CreditCardCvvMask';
import { CreditCardExpirationDateMask } from './CreditCardExpirationDateMask';
import CreditCardNumberMask from './CreditCardNumberMask';
import DateMask from './DateMask';
import MoneyMask from './MoneyMask';
import NumberMask from './NumberMask';
import PhoneMask from './PhoneMask';
import ZipCodeMask from './ZipCodeMask';

export {
  CNPJMask,
  CPFMask,
  CreditCardCvvMask,
  CreditCardExpirationDateMask,
  CreditCardNumberMask,
  DateMask,
  MoneyMask,
  NumberMask,
  PhoneMask,
  ZipCodeMask,
};

export type MaskProps = {
  mask?:
    | 'date'
    | 'phone'
    | 'cpf'
    | 'cnpj'
    | 'zipCode'
    | 'money'
    | 'creditCardNumber'
    | 'creditCardExpirationDate'
    | 'creditCardCvv'
    | 'number';
};

export const Masks = {
  cpf: CPFMask,
  cnpj: CNPJMask,
  date: DateMask,
  phone: PhoneMask,
  zipCode: ZipCodeMask,
  money: MoneyMask,
  creditCardNumber: CreditCardNumberMask,
  creditCardExpirationDate: CreditCardExpirationDateMask,
  creditCardCvv: CreditCardCvvMask,
  number: NumberMask,
};
